import { render, staticRenderFns } from "./ColorPickerPreDefinedSelect.vue?vue&type=template&id=3ec1d17a&scoped=true"
import script from "./ColorPickerPreDefinedSelect.vue?vue&type=script&lang=js"
export * from "./ColorPickerPreDefinedSelect.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerPreDefinedSelect.vue?vue&type=style&index=0&id=3ec1d17a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec1d17a",
  null
  
)

export default component.exports